<template>
  <div class="">
    <el-card
      class="settings"
      shadow="never">
      <div
        slot="header"
        class="settings-header">企业组件<el-button
          type="danger"
          style="margin-left: 8px;"
          @click="deleteitem">删除</el-button></div>
      <el-form
        ref="series"
        :model="series"
        label-width="100px">
        <el-form-item
          label=""
          label-width="0">
          <el-button
            type="primary"
            style="margin-bottom: 10px;"
            @click="addGoods">选择企业</el-button>
          <el-table
            border
            :data="series.graphics">
            <el-table-column
              label="企业名称"
              min-width="180"
              prop="vendorName"> </el-table-column>
            <el-table-column
              label="操作"
              width="80"
              prop="vendorAddress">
              <template slot-scope="{ row, $index }">
                <el-button
                  type="text"
                  @click="deleteRow($index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>

      <we-vendor-select-modal
        ref="vendor"
        @select="handleSelect" />
    </el-card>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import WeVendorSelectModal from './we-vendor-select-modal.vue'
export default {
  name: 'WeVendor',
  components: { WeVendorSelectModal },
  props: {
    value: {
      type: Object,
      default() {
        return { componentName: 'vendorshow', graphics: [], layoutType: 2, visible: false }
      }
    },
    index: Number
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo
    }),
    series: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      }
    }
  },
  methods: {
    deleteitem() {
      this.$emit('deleteItem', this.index)
    },
    deleteRow($index) {
      this.series.graphics.splice($index, 1)
    },
    addGoods() {
      const selection = this.series.graphics.map(i => i.vendorId)
      this.$refs.vendor.fetch(selection)
    },
    handleSelect(row) {
      console.log(this.series)
      this.$message.success('添加成功')
      this.series.graphics.push(row)
    },
    submit() {
      return new Promise((resolve, reject) => {
        const graphics = this.series.graphics
        if (graphics.length === 0) {
          this.$message.error('请选择合作企业')
          reject(new Error(JSON.stringify({ index: this.index })))
        } else {
          resolve()
        }
        // this.$refs.series.validate(v => {
        //   if (v) {
        //     resolve()
        //   } else {
        //     reject(new Error(JSON.stringify({ index: this.index })))
        //   }
        // })
      })
    }
  }
}
</script>
